import { Badge, styled } from '@mui/material';

export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-dot': {
    height: 14,
    minWidth: 14,
    borderRadius: 10,
    top: theme.spacing(3),
    right: theme.spacing(3),
  },
}));
